<template>
  <div class="analytics-count">
    <div class="analytics-count__title">
      <h2>{{ title }}</h2>
    </div>
    <div class="analytics-count__content">
      <div class="analytics-count__content-item">
        <div class="input_block">
          <p>От</p>

          <input class="form-control mb-2 mr-sm-2" type="date"
                 v-model="startDate"
                 required>
        </div>
        <div class="input_block">
          <p>По</p>

          <input class="form-control mb-2 mr-sm-2" type="date" id="to-date-input"
                 v-model="endDate"
                 required>
        </div>
        <div class="input_block">
          <p>От</p>

          <input class="form-control mb-2 mr-sm-2" type="number" id="skip-date-input" v-model.number="skip">
        </div>
        <div class="input_block">
          <p>До</p>
          <input class="form-control mb-2 mr-sm-2" type="number" id="limit-date-input"
                 v-model.number="limit"
          >
        </div>
      </div>
      <div class="button_block">
        <button class="btn btn-primary"
                @click="getData()">Показать
        </button>
      </div>

      <div class="table-responsive">
        <data-table v-bind="bindings"/>
      </div>
    </div>
    <div class="analytics-count__title">
      <h2>Статистика по заявкам</h2>
    </div>
    <div class="analytics-count__content">

      <div class="button_block">
        <button class="btn btn-primary"
                @click="getDataStatic()">Обновить
        </button>
      </div>

      <div class="table-responsive">
        <data-table v-bind="bindingsStatic"/>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../services/api.js"

export default {
  name: "analyticsCount",
  data() {
    return {
      dataBindingsStatic: [],
      skip: 0,
      limit: 500,
      dataJson: {
        action: 'dateAge',
        optional: {
          start: '',
          finish: ''
        },
        params: Object()
      },
      data_table: [],
      endDate: new Date().toISOString().slice(0, 10),
      startDate: '',
      title: 'Статистика по городам',
      content: {
        title: 'analyticsCount',
        count: 'analyticsCount'
      }
    }
  },

  computed: {

    bindings() {
      return {
        data: this.data_table,
        showEntriesInfo: false,
        actionMode: "multiple",
		defaultPerPage: 400,
		perPageSizes: [400],
		showPerPage: false,
		showPagination: false,
        columns: [
          {
            key: 'key',
            title: 'Город',
            sortable: true,
            cssClass: 'text-center',

          },
          {
            key: 'count',
            title: 'Количество',
            sortable: true,
            type: 'number',


          },
        ],
        text: {
          downloadFileName: (new Date()).toLocaleDateString(),
          nextButtonText: "Дальше",
          perPageText: "Показать :entries записей",
          previousButtonText: "Назад",
          paginationSearchText: "Перейти на страницу",
          paginationSearchButtonText: "Перейти",
          searchText: "Поиск:",
          downloadText: "экспорт как:",
          downloadButtonText: "Скачать",
        }
      }
    },
    bindingsStatic() {
      return {
        data: this.dataBindingsStatic,
        showEntriesInfo: false,
        actionMode: "multiple",
		showPerPage: false,
		showPagination: false,
        columns: [
          {
            key: 'key',
            title: 'Время',
            sortable: true,
            cssClass: 'text-center',

          },
          {
            key: 'count',
            title: 'Количество',
            sortable: true,
            type: 'number',


          },
        ],
        text: {
          downloadFileName: (new Date()).toLocaleDateString(),
          nextButtonText: "Дальше",
          perPageText: "Показать :entries записей",
          previousButtonText: "Назад",
          paginationSearchText: "Перейти на страницу",
          paginationSearchButtonText: "Перейти",
          searchText: "Поиск:",
          downloadText: "экспорт как:",
          downloadButtonText: "Скачать",
        }
      }
    },
  },
  methods: {
    async getData() {
      let url = '/stati/count/city';
      try {

        let response = await api.post(url, this.dataJson, {params: {skip: this.skip, limit: this.limit}});
        if (response.status === 200) {
          this.data_table = response.data;
        }
      } catch (error) {
        this.alert(JSON.stringify(error.response.data), "Error", "error", {
          reverseButtons: true
        });
      }


    },
    async getDataStatic() {
      let url = '/statistics/';
      try {

        let response = await api.get(url);
        if (response.status === 200) {
          this.dataBindingsStatic = response.data;
        }
      } catch (error) {
        this.alert(JSON.stringify(error.response.data), "Error", "error", {
          reverseButtons: true
        });
      }
    },
  },
  created() {
    this.startDate = localStorage.getItem('startDateAN')
    this.endDate = new Date().toISOString().slice(0, 10)
    this.dataJson.optional.start = this.startDate
    this.dataJson.optional.finish = this.endDate
    this.getData();
    this.getDataStatic();
  },
  watch: {
    startDate: function (newVal, oldVal) {
      this.dataJson.optional.start = newVal
      localStorage.setItem('startDateAN', newVal)
    },
    endDate: function (newVal, oldVal) {
      this.dataJson.optional.finish = newVal
      localStorage.setItem('endDateAN', newVal)
    },
  }
}
</script>

<style scoped>
.analytics-count {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.analytics-count__content {
  margin-bottom: 20px;
}

.analytics-count__content-item {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 0;
}

.input_block {
  margin-right: 10px;
}

.input_block p {
  margin-bottom: 3px;
}

.input_block label {
  color: #222;
}

.button_block {
  margin-top: 10px;
  text-align: right;
}
</style>
